// Copyright (c) 2021, Elicenciamento. All rights reserved.

import { isEmpty, prop, reject, sum } from "ramda";

const emptyAmount = (n) => Number.isNaN(n) || n === undefined || isEmpty(n);
const divideBy = (source) => (source === "rendimento" ? 100 : 1);
const plusBy = (source) => (source === "datacube" ? 100 : 1);

const sumByAmount = (resource) => {
  if (isEmpty(resource)) return 0;

  return resource?.reduce(
    (accumulator, current) => Number(accumulator) + Number(current.amount),
    0
  );
};

const buildFee = (source, data, attribute, remove_transfer) => {
  if (source === "datacube" && attribute === "licensingFee") {
    return data?.licensing;
  }

  return [
    {
      amount: remove_transfer ? 0 : prop(attribute, data),
      exercise: data?.exercise || new Date().getFullYear(),
    },
  ];
};

const prepareDebts = (debt, source) => {
  return {
    debt,
    totalAmount: sumByAmount(debt) / divideBy(source),
  };
};

const buildDebts = (
  { source, plate, createdAt, data, id },
  remove_transfer
) => {
  const debts = {};
  const licensing = buildFee(source, data, "licensingFee", remove_transfer);
  const transfer = buildFee(source, data, "transferFee", remove_transfer);

  const totalAmounts = reject(emptyAmount, [
    sumByAmount(licensing),
    sumByAmount(transfer),
    sumByAmount(data?.fines),
    sumByAmount(data?.ipvas),
    sumByAmount(data?.dpvats),
    sumByAmount(data?.activeDebts),
  ]);

  debts.id = id;
  debts.plate = plate;
  debts.renavam = data?.vehicle?.renavam;
  debts.cpfOwner = data?.vehicle?.vehicleOwner;
  debts.source = source;
  debts.createdAt = createdAt;

  const preparedLicensing = prepareDebts(licensing, source);
  const preparedTransfer = prepareDebts(transfer, source);

  if (remove_transfer === false && Number(preparedTransfer?.totalAmount) > 0) {
    debts.transfer = preparedTransfer;
  }
  if (remove_transfer === false && Number(preparedLicensing?.totalAmount) > 0) {
    debts.licensing = preparedLicensing;
  }

  debts.fines = prepareDebts(data?.fines, source);
  debts.ipvas = prepareDebts(data?.ipvas, source);
  debts.dpvats = prepareDebts(data?.dpvats, source);
  debts.activeDebts = prepareDebts(data?.activeDebts, source);

  const licensingMultiplier = licensing?.length > 0 ? licensing?.length : 1;

  const buildOurFee = (transfer, remove_transfer, licensingMultiplier) => {
    if (transfer?.totalAmount > 0 && remove_transfer === false) {
      // eslint-disable-next-line prettier/prettier
      return 19000 + (8000 * licensingMultiplier );
    }

    return 8000 * licensingMultiplier;
  };

  debts.fees = buildOurFee(
    preparedTransfer,
    remove_transfer,
    licensingMultiplier
  );

  debts.deliveryFee = 2000;
  debts.totalAmount = sum(totalAmounts) / divideBy(source) + debts.fees / 100;
  debts.totalAmountInCents = sum(totalAmounts) * plusBy(source) + debts.fees;

  return debts;
};

export { buildDebts, emptyAmount };
